var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#13CC95"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_455_2555",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_455_2555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9 52.3787L23.0215 40.5002L25.8785 37.6437L34.9 46.6652L54.0715 27.4937L56.9285 30.3502L34.9 52.3787Z",
    fill: "#0B0E4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCheck);
export default __webpack_public_path__ + "static/media/NewCheck.0bfbe29704a03781335e734c999eb6d6.svg";
export { ForwardRef as ReactComponent };